(function () {
  function init() {
    document.querySelectorAll('.social-grid-carousel').forEach(function (carousel) {
      var dots = carousel.parentElement.querySelectorAll('.dot');
      var images = carousel.querySelectorAll('.carousel-image');
      if (images.length === 0) return;

      var cachedWidth = carousel.clientWidth || 1;
      var scrollScheduled = false;
      var activeIndex = -1;

      var activateDot = function (index) {
        if (index === activeIndex) return;
        activeIndex = index;
        dots.forEach(function (dot, i) { dot.classList.toggle('active', i === index); });
      };

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var index = Number(dot.dataset.index);
          var target = images[index];
          if (!target) return;
          carousel.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          activateDot(index);
        });
      });

      carousel.addEventListener('scroll', function () {
        if (scrollScheduled) return;
        scrollScheduled = true;
        requestAnimationFrame(function () {
          scrollScheduled = false;
          var index = Math.round(carousel.scrollLeft / cachedWidth);
          activateDot(index);
        });
      }, { passive: true });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          cachedWidth = carousel.clientWidth || 1;
        }, 150);
      }, { passive: true });

      activateDot(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
